import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLogin from "@/pages/AdminLogin";
import KYCDetail from "@/pages/admin/KYCDetail";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminUserDetail from "@/pages/admin/AdminUserDetail";
import AdminTransactions from "@/pages/admin/AdminTransactions";
import AdminWithdrawals from "@/pages/admin/AdminWithdrawals";
import AdminTickets, { AdminTicketDetail } from "@/pages/admin/AdminTickets";
import AdminStatements from "@/pages/admin/AdminStatements";
import Deposit from "@/pages/Deposit";
import Withdraw from "@/pages/Withdraw";
import Transfer from "@/pages/Transfer";
import Cards from "@/pages/Cards";
import Banks from "@/pages/Banks";
import Transactions from "@/pages/Transactions";
import Statements from "@/pages/Statements";
import Exchange from "@/pages/Exchange";
import Settings from "@/pages/Settings";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Help from "@/pages/Help";
import VerifyReceipt from "@/pages/VerifyReceipt";
import Crypto from "@/pages/Crypto";
import VerifyIdentity from "@/pages/VerifyIdentity";
import InactivityWatcher from "@/components/InactivityWatcher";

function Root() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#4F4D45]">
        Opening your vault…
      </div>
    );
  }
  if (!user) return <Landing />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/app"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <InactivityWatcher />
          <Routes>
            <Route path="/" element={<Root />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/help" element={<Help />} />
            <Route path="/verify" element={<VerifyReceipt />} />
            <Route path="/app" element={<Dashboard />} />
            <Route path="/app/deposit" element={<Deposit />} />
            <Route path="/app/withdraw" element={<Withdraw />} />
            <Route path="/app/transfer" element={<Transfer />} />
            <Route path="/app/cards" element={<Cards />} />
            <Route path="/app/banks" element={<Banks />} />
            <Route path="/app/crypto" element={<Crypto />} />
            <Route path="/app/verify-identity" element={<VerifyIdentity />} />
            <Route path="/app/transactions" element={<Transactions />} />
            <Route path="/app/statements" element={<Statements />} />
            <Route path="/app/exchange" element={<Exchange />} />
            <Route path="/app/settings" element={<Settings />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/kyc" element={<AdminDashboard />} />
            <Route path="/admin/kyc/:id" element={<KYCDetail />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/users/:id" element={<AdminUserDetail />} />
            <Route path="/admin/transactions" element={<AdminTransactions />} />
            <Route path="/admin/withdrawals" element={<AdminWithdrawals />} />
            <Route path="/admin/tickets" element={<AdminTickets />} />
            <Route path="/admin/tickets/:ticket_id" element={<AdminTicketDetail />} />
            <Route path="/admin/statements" element={<AdminStatements />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
